import { useState, useEffect } from "react";

const useTableState = (
  request,
  {
    initParams = { page: 1, pageSize: 10 },
    hasOtherRequest = false, // 有无除了列表之外的请求，当为true时默认的第一次的列表请求不发出
    tabRequest, // tabList的请求方法
    tabParams, // 请求tabList的参数
    tabQuery // 有tab时发请求的tab参数名
  } = {}
) => {
  const [params, setParams] = useState(initParams); // 列表的请求参数
  const [pageInfo, setPageInfo] = useState({ page: 1, pageSize: 10 });

  const [list, setList] = useState([]); // 列表的list
  const [tabList, setTabList] = useState([]); // tab的list

  const [tabKey, setTabKey] = useState(); // 当tab修改时，修改当前tabKey，把外部的的tabKey维护在当前hooks里，为了控制请求的发出，注意数据结构是否符合

  const [loading, setLoading] = useState(false);

  // 当外部请求参数修改时，修改params，发出列表的list请求
  const handleQueryChange = ({ query }) => {
    setParams({
      ...params,
      page: 1,
      pageSize: 10,
      ...query
    });
  };

  // 分页信息修改，修改params，发出列表的list请求
  const handlePaginationChange = (page, pageSize) => {
    setParams({
      ...params,
      page,
      pageSize
    });
  };

  // 当tab修改时，修改hooks维护的tabKey，并且发出请求
  const handleTabChange = tab => {
    setTabKey(tab);
    setParams({
      ...params,
      page: 1,
      pageSize: 10,
      [tabQuery]: tab,
      ...tabParams
    });
  };

  // 请求tab的副作用，请求回来之后默认取第一个tab，发出列表请求，注意数据结构
  useEffect(() => {
    if (tabRequest) {
      tabRequest(tabParams).then(res => {
        const { content } = res;
        setTabList(content);
        setTabKey(content[0]);
        setParams({
          page: 1,
          pageSize: 10,
          [tabQuery]: content[0],
          ...tabParams
        });
      });
    }
  }, []);

  // 列表的请求
  useEffect(() => {
    // 列表请求不依赖其他请求之后，直接发出
    // 列表请求依赖其他请求之后，当其他请求已经完成，再发出
    if ((hasOtherRequest && tabList && tabList.length) || !hasOtherRequest) {
      setLoading(true);
      request(params)
        .then(res => {
          const { page, totalElements, pageSize, content } = res;
          setPageInfo({
            page,
            pageSize,
            totalElements
          });
          setList(content);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [params]);

  return {
    params,
    pageInfo,
    list,
    tabList,
    loading,
    tabKey,
    handleTabChange,
    handlePaginationChange,
    handleQueryChange
  };
};

export default useTableState;
